const validate = values => {
  const errors = {}

  if (
    !values.refer_friend_form?.emailContent ||
    values.refer_friend_form?.emailContent === "<p><br></p>"
  ) {
    errors.refer_friend_form = {
      ...errors.refer_friend_form,
      emailContent: "The text is required!",
    }
  }

  return errors
}

export default validate
